export const mutations = {
    setCurrentFps(state, payload) {
        state.currentFps = payload
    },
    setFrameReceived(state, payload) {
        state.frameReceived = payload
    },
}
